import { useEffect, useState } from 'react';
import { IBancoDTO, IContaDTO, ITipoContaCleanDTO } from '../../../../models/happy-code-api.model';
import { useContaService } from '../../../../services/conta.service';
import { useGlobalContext } from '../../../../context/GlobalContext';
import { useTipoContaService } from '../../../../services/tipo-conta.service';
import { useNotificationService } from '../../../../services/notification.service';
import { useBancoService } from '../../../../services/banco.service';
import { Predicate } from '../../../../models/predicate.model';

export default function useSaveConta() {
	const [conta, setConta] = useState<IContaDTO>();
	const [tipoConta, setTipoConta] = useState<ITipoContaCleanDTO[]>();
	const [bancos, setBancos] = useState<IBancoDTO[]>();
	const [isModalCadastroConta, setisModalCadastroConta] = useState<boolean>(false);
	const { setIsGlobalLoading, unidade } = useGlobalContext();
	const notification = useNotificationService();

	const contaService = useContaService();
	const tipoContaService = useTipoContaService();
	const bancoService = useBancoService();

	const fetchTipoContas = () => {
		setIsGlobalLoading(true);
		tipoContaService
			.findCleanList()
			.then(({ data }) => setTipoConta(data))
			.finally(() => setIsGlobalLoading(false));
	};
	const createOrPatchConta = async (conta: IContaDTO) => {
		conta.unidade = { ...conta?.unidade, id: unidade?.id };
		setIsGlobalLoading(true);
	
		try {
			const { data } = await contaService.createCustom(conta);
			setConta(data);
			notification({
				description: `Conta cadastrada com sucesso!`,
				type: 'success',
				message: 'Sucesso!',
			});
		} finally {
			fetchTipoContas();
			setIsGlobalLoading(false);
		}
	};
	
	const findBancos = async () => {
		const predicate = new Predicate();
		predicate.addOption('ativo', true);
		setIsGlobalLoading(true);
		bancoService
			.findList(predicate)
			.then(({ data }) => setBancos(data))
			.finally(() => setIsGlobalLoading(false));

	};

	useEffect(() => {
		fetchTipoContas();
		findBancos();
	}, []);

	return {
		conta,
		tipoConta,
		isModalCadastroConta,
		setisModalCadastroConta,
		setConta,
		createOrPatchConta,
		bancos,
		setIsGlobalLoading
	};
}
